// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { InternalUserDetailFragmentDoc } from '../../../../fragments/circularFragments.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ActivityTabDataQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ActivityTabDataQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string } | null | undefined, internalUsers: Array<{ __typename?: 'InternalUser', id: string, name: string, avatar: string }>, userEventParentTypes: Array<{ __typename?: 'UserEventParentType', id: string, name: string }> };


export const ActivityTabDataDocument = gql`
    query ActivityTabData {
  currentUser {
    id
  }
  internalUsers {
    ...InternalUserDetail
  }
  userEventParentTypes {
    id
    name
  }
}
    ${InternalUserDetailFragmentDoc}`;

/**
 * __useActivityTabDataQuery__
 *
 * To run a query within a React component, call `useActivityTabDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityTabDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityTabDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useActivityTabDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ActivityTabDataQuery, ActivityTabDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ActivityTabDataQuery, ActivityTabDataQueryVariables>(ActivityTabDataDocument, options);
      }
export function useActivityTabDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ActivityTabDataQuery, ActivityTabDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ActivityTabDataQuery, ActivityTabDataQueryVariables>(ActivityTabDataDocument, options);
        }
// @ts-ignore
export function useActivityTabDataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ActivityTabDataQuery, ActivityTabDataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ActivityTabDataQuery, ActivityTabDataQueryVariables>;
export function useActivityTabDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ActivityTabDataQuery, ActivityTabDataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ActivityTabDataQuery | undefined, ActivityTabDataQueryVariables>;
export function useActivityTabDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ActivityTabDataQuery, ActivityTabDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ActivityTabDataQuery, ActivityTabDataQueryVariables>(ActivityTabDataDocument, options);
        }
export type ActivityTabDataQueryHookResult = ReturnType<typeof useActivityTabDataQuery>;
export type ActivityTabDataLazyQueryHookResult = ReturnType<typeof useActivityTabDataLazyQuery>;
export type ActivityTabDataSuspenseQueryHookResult = ReturnType<typeof useActivityTabDataSuspenseQuery>;
export type ActivityTabDataQueryResult = ApolloReactCommon.QueryResult<ActivityTabDataQuery, ActivityTabDataQueryVariables>;